// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 获取回测信息 GET /back-test/info */
export async function backTestInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.backTestInfoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultStrategyRevenueStatisticsResp>('/back-test/info', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取回测通道信息 GET /back-test/passageways */
export async function backTestPassagewaysUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.backTestPassagewaysUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListStrategyPassagewayStatisticsResp>('/back-test/passageways', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取策略交易详细 GET /back-test/strategy/trade-detail */
export async function backTestStrategyTradeDetailUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.backTestStrategyTradeDetailUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListCustomerTradeDetailResp>('/back-test/strategy/trade-detail', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取策略回撤统计 GET /back-test/strategy/trade/statistics */
export async function backTestStrategyTradeStatisticsUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.backTestStrategyTradeStatisticsUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultCustomerTradeStatisticsResp>(
    '/back-test/strategy/trade/statistics',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 获取策略回测交易统计信息 GET /back-test/trade/statistics/info */
export async function backTestTradeStatisticsInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.backTestTradeStatisticsInfoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultStrategyBackTestTradeStatisticInfoResp>(
    '/back-test/trade/statistics/info',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 获取策略回撤走势列表 GET /back-test/trade/statistics/list */
export async function backTestTradeStatisticsListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.backTestTradeStatisticsListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListRatioResp>('/back-test/trade/statistics/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
